import './App.scss';
import React from "react";
import SearchByVehicleInfo from "../FindNewTires/searchByVehicleInfo";
import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
import DealerLocator from "../DealerLocator/DealerLocator";
import Cart from "../Cart/Cart";
import TireResults from "../SearchResults/TireResults";
import ProductDetail from "../SearchResults/Detail/ProductDetail";
import CompareTires from "../SearchResults/Detail/CompareTires";
import CSSRenderer from "../../shared/util/CSSRenderer";
import Email from "../component/email";
import Widget from "../Widget/Widget";
import {useDispatch} from "react-redux";
import {setAdobeReadyFlag, setPathname} from "../../core/redux/ActionCreator";
import {createBrowserHistory} from "history";
import ScrollToTop from "./ScrollToTop";
import Params from "../../shared/util/Params";

export const browserHistory = createBrowserHistory({
    basename: '/tirefinder/',
});

function App() {
    let pathname = window.location.pathname;
    const dispatch = useDispatch();
    document.getElementById("adobeScript").addEventListener('load', () => {
        dispatch(setAdobeReadyFlag(true));
    });

    dispatch(setPathname(pathname));
    Params();
    CSSRenderer();

    return (
        <Router basename={'/tirefinder'}>
            <ScrollToTop />
            <div className="mainContainer">
                <Switch>
                    <Route path="/dealerLocator"><DealerLocator/></Route>
                    <Route path="/searchResult"><TireResults/></Route>
                    <Route path="/productDetail"><ProductDetail/></Route>
                    <Route path="/compareTires"><CompareTires/></Route>
                    <Route path="/cart"><Cart/></Route>
                    <Route path="/email"><Email/></Route>
                    <Route path="/widget"><Widget/></Route>
                    <Route path="/">{pathname.toString().includes('widget')?<Widget/>:<SearchByVehicleInfo/>}</Route>
                </Switch>
            </div>
        </Router>
    )
}
export default App;
